import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from "react-helmet-async";
import Sentry from "components/Sentry";
import setupLogService from "stores/setupLogService";
import { store, persistor } from "stores/store";
import App from "./App";

setupLogService();

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Sentry>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </Sentry>
    </PersistGate>
  </Provider>
);

/* eslint-disable no-console */
console.log(`Release date: ${RELEASE_DATE}`);
console.log(`Version hash: ${VERSION_HASH}`);
